<div class="txt-align-left">
  <h2>{{ title }}</h2>
</div>
<div class="hyperlinks" *ngIf="links && links.length > 0">
  <div class="layout-flex">
    <ng-container *ngFor="let link of links; let i = index">
      <vm-link class="link vm-col-xs-6 vm-col-md-3 vm-col-lg-2" [type]="linkType" href="{{ link.url }}">
        {{ link.label }}
      </vm-link>
    </ng-container>
  </div>
</div>
